import APIService from '@/services/APIService';

export default {

  /**
   * Получить список курсов отправленных владельцем на биржу
   *
   * @param params
   */
  getOwnSellingCoursesList(params) {
    const config = { params };
    return APIService.get('/course-exchanges', config);
  },

  /**
   * Отправить курс на биржу
   *
   * @param data
   * @returns {*}
   */
  placeCourseOnExchange(data) {
    return APIService.post('/course-exchanges', data);
  },

  /**
   * Получить информацию по конкретному курсу владельца на бирже
   *
   * @param {int} id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getOwnSellingCourse(id) {
    return APIService.get(`/course-exchanges/${id}`);
  },

  /**
   * Изменить курс на бирже
   *
   * @param id
   * @param data
   * @returns {Promise<AxiosResponse<T>>}
   */
  updateOwnSellingCourse(id, data) {
    return APIService.put(`/course-exchanges/${id}`, data);
  },

  /**
   * Деактивировать курс на бирже
   *
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  deactivateOwnSellingCourse(id) {
    return APIService.post(`/course-exchanges/${id}/deactivate`);
  },

  /**
   * Активировать курс на бирже
   *
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  activateOwnSellingCourse(id) {
    return APIService.post(`/course-exchanges/${id}/activate`);
  },

  /**
   * Удалить курс с биржи
   *
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  deleteOwnSellingCourse(id) {
    return APIService.delete(`/course-exchanges/${id}`);
  },

  /**
   * Получить список всех курсов доступных на бирже
   *
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  getAllSellingCoursesList(params) {
    const config = { params };
    return APIService.get('/exchange', config);
  },

  /**
   * Получить перечень заявок от пользователей на приобретение курса
   *
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  getOwnCoursesRequestsList(params) {
    const config = { params };
    return APIService.get('/course-orders', config);
  },

  /**
   * Отправить заявку на курс
   *
   * @param data
   * @returns {*}
   */
  createCourseRequest(data) {
    return APIService.post('/course-orders', data);
  },

};
